@if (exerciseItems(); as exerciseItems) {
<lib-select-exercise-list [items]="exerciseItems" [selectExerciseButtonText]="'See details'"></lib-select-exercise-list>
}
